import { jsPDF } from 'jspdf';
import { useAuth } from '../../../../hooks/useAuth';
import trophyImg from '../../../../assets/images/step-4.png';
import styles from './CertificateModal.module.css';

interface CertificateModalProps {
  certificateUrl: string;
  onClose: () => void;
}

export function CertificateModal({
  certificateUrl,
  onClose,
}: CertificateModalProps) {
  const { player } = useAuth();

  async function handleDownload() {
    try {
      const response = await fetch(`https://${certificateUrl}`);
      const blob = await response.blob();
      const imgUrl = URL.createObjectURL(blob);

      const img = new Image();
      img.src = imgUrl;
      await img.decode();

      const pdf = new jsPDF({
        orientation: img.width > img.height ? 'landscape' : 'portrait',
        unit: 'px',
        format: [img.width, img.height],
      });
      pdf.addImage(imgUrl, 'JPEG', 0, 0, img.width, img.height);
      pdf.save('certificado.pdf');
      URL.revokeObjectURL(imgUrl);
    } catch {
      window.open(`https://${certificateUrl}`, '_blank');
    }
  }

  function handleLinkedIn() {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(certificateUrl)}`,
      'pop',
      'width=600,height=400,scrollbars=no'
    );
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose}>
          <i className="material-icons">close</i>
        </button>

        <div className={styles.header}>
          <img className={styles.trophy} src={trophyImg} alt="Troféu" />
          <h2 className={styles.title}>
            Parabéns, {player?.displayName || player?.name || 'Jogador'}!
          </h2>
          <p className={styles.subtitle}>
            Você cumpriu todas as etapas do treinamento com sucesso!
          </p>
        </div>

        <div className={styles.certificateWrapper}>
          <img
            className={styles.certificateImage}
            src={`https://${certificateUrl}`}
            alt="Certificado"
          />
        </div>

        <div className={styles.actions}>
          <button className={styles.downloadBtn} onClick={handleDownload}>
            <i className="material-icons-outlined">download</i>
            Baixar Certificado
          </button>
          <button className={styles.linkedinBtn} onClick={handleLinkedIn}>
            <i className="material-icons-outlined">share</i>
            Compartilhar no LinkedIn
          </button>
        </div>
      </div>
    </div>
  );
}
